import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { Ionicons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";

import DiagnosticsScreen from "./Settings/Troubleshooting/DiagnosticsScreen";

function PreSessionDiagnosticScreen(): React.JSX.Element {
  const navigation = useNavigation();

  const handleGoBack = (): void => {
    navigation.goBack();
  };

  return (
    <SafeAreaView
      style={styles.container}
      edges={["top", "left", "right"]} // Specify which edges to apply safe area insets
    >
      <View style={styles.header}>
        <TouchableOpacity
          onPress={handleGoBack}
          style={styles.backButton}
          accessibilityRole="button"
          accessibilityLabel="Go back"
        >
          <Ionicons name="arrow-back" size={24} color="#000" />
          <Text style={styles.backText}>Back</Text>
        </TouchableOpacity>
      </View>

      <DiagnosticsScreen />
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1, // Fill the entire screen
    backgroundColor: "#FFFFFF", // Match your app's background color
  },
  header: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    flexDirection: "row",
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#EEEEEE",
  },
  backButton: {
    flexDirection: "row",
    alignItems: "center",
    padding: 4,
  },
  backText: {
    marginLeft: 4,
    fontSize: 16,
    fontWeight: "500",
    color: "#000",
  },
});

export default PreSessionDiagnosticScreen;
